<template>
  <div>
    <Modal
      v-model="_thismodal"
      :closable="false"
      :mask-closable="false"
      :title="`${title}操作员`"
      width="20%"
    >
      <table class="TB_COLLAPSE" width="100%">
        <thead>
          <th colspan="2">{{title}}操作员</th>
        </thead>
        <tbody>
          <tr>
            <th>帐号</th>
            <td>
              <Input v-model="form.uname" v-if="stateModal.state === '1'" style="width:90%;" />
              <p v-if="stateModal.state === '2'">{{form.uname}}</p>
            </td>
          </tr>
          <tr>
            <th>密码</th>
            <td>
              <Input v-model="form.upass" style="width:90%;" />
            </td>
          </tr>
          <tr>
            <th>确认密码</th>
            <td>
              <Input v-model="form.twopass" style="width:90%;" />
            </td>
          </tr>
          <tr>
            <th>姓名</th>
            <td>
              <Input v-model="form.name" style="width:90%;" />
            </td>
          </tr>
          <tr>
            <th>电话号码</th>
            <td>
              <Input v-model="form.phone" style="width:90%;" />
            </td>
          </tr>
          <tr>
            <th>操作员组</th>
            <td>
              <Select style="width:90%;" v-model="form.opergpop">
                <Option
                  v-for="(item,index) in select"
                  :value="item.id"
                  :key="index+'select'"
                >{{ item.name }}</Option>
              </Select>
            </td>
          </tr>
          <tr>
            <th>备注</th>
            <td>
              <Input v-model="form.remark" style="width:90%;" />
            </td>
          </tr>
        </tbody>
      </table>
      <div slot="footer">
        <Button type="primary" @click="$emit('update:modal', false)">取消</Button>
        <Button type="error" @click="checkfun()">{{title}}</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapState, mapActions } from "vuex";
export default {
  name: 'OperatorSetting',
  props: {
    modal: Boolean,
    stateModal: {
      // state: { 1: 新增, 2: 修改 }
      type: Object
    }
  },
  data () {
    return {
      select: [],
      modifyStatus: false,
      form: {
        opergpop: "",
        uname: "",
        upass: "",
        twopass: "",
        name: "",
        phone: "",
        remark: ""
      }
    };
  },
  created () {
    this.getselect();
  },
  computed: {
    ...mapGetters(['getmember']),
    _thismodal: {
      get () {
        if (this.stateModal.state === "2") return this.modal && this.modifyStatus
        if (this.stateModal.state !== "2") return this.modal;
      },
      set (val) {
        this.$emit("update:modal", val);
      }
    },
    title () {
      return this.stateModal.state == 1 ? "新增" : "修改";
    }
  },
  watch: {
    modal (val) {
      if (val && this.stateModal.state === "2") this.getOperatorData();
      if (!val) this.resetdata();
    }
  },
  methods: {
    resetdata () {
      Object.keys(this.form).map(it => (this.form[it] = ""));
      this.form.opergpop = this.select[0].id;
    },
    async getselect () {
      try {
        const res = await this.$axios.operator.opergpop()
        if ('status' in res && res.status === 0) return
        this.select = res
        this.form.opergpop = res[0].id;
      } catch (error) {
        console.error(error)
      }
    },
    async getOperatorData () {
      try {
        const res = await this.$axios.operator.getOperatorData(this.stateModal.listid)
        if ('status' in res && res.status === 0) return
        this.modifyStatus = true
        this.form.opergpop = res[0].opergroup;
        this.form.uname = res[0].username;
        this.form.remark = res[0].remark;
        this.form.name = res[0].memname;
        this.form.phone = res[0].phone;
      } catch (error) {
        console.error(error)
        this._thismodal = false
      }
    },
    checkfun () {
      if (this.stateModal.state == "1") {
        this.addOperator();
      } else {
        this.modifyOperator();
      }
    },
    async addOperator () {
      try {
        const res = await this.$axios.operator.addOperator(this.form);
        if (res.status === 1) {
          this.$Message.success("已新增");
          this.$emit("update:modal", false);
          this.$emit("ResetList");
        }
      } catch (err) {
        console.log(err);
        this.$Message.error("请将栏位填写完整");
      }
    },
    async modifyOperator () {
      try {
        const res = await this.$axios.operator.modifyOperator({
          loid: this.getmember.pid,
          oid: this.stateModal.listid,
          upass: this.form.upass,
          name: this.form.name,
          phone: this.form.phone,
          opergpop: this.form.opergpop,
          remark: this.form.remark,
        });
        if (res.status === 1) {
          this.$Message.success("已修改");
          this.$emit("update:modal", false);
          this.$emit("ResetList");
        }
      } catch (err) {
        console.log(err);
        this.$Message.error("请将栏位填写完整");
      }
    }
  }
};
</script>
